import styled, { css } from 'styled-components';
import { Spacer, TextFontSize } from '@lux/tokens';
import { ColorMode, mediaMinWidth } from '@lux/core';
import { FunctionColor, Text } from '@lux/text';

export const UpcomingCampaignCardMiniWrapper = styled.div<{ bgTransparent: boolean }>`
    position: relative;
    transition: all 0.33s ease-in-out;

    background: ${({ bgTransparent, theme }) => {
        if (bgTransparent) return 'transparent';
        return theme.colorMode === ColorMode.DARK ? '#1a1a1a' : FunctionColor.function0;
    }};
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const ImageWrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
`;

export const CampaignImage = styled.img`
    height: 100%;
    margin: auto;
    width: 100%;
    object-fit: contain;
`;

export const BottomSection = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${Spacer.S} ${Spacer.XS};
`;

export const OverflowContainer = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const outOfLuxButtonBase = css`
    width: 100%;
    height: ${Spacer.L};
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${Spacer.XS};
    cursor: pointer;
`;

interface OutOfLuxButtonProps {
    isNotificationRequested: boolean;
}

const outOfLuxButtonColors = ({ isNotificationRequested }: OutOfLuxButtonProps) => css`
    background-color: ${isNotificationRequested
        ? FunctionColor.function5
        : FunctionColor.function0};
    border: 1px solid
        ${isNotificationRequested ? FunctionColor.function5 : FunctionColor.function100};
`;

const outOfLuxButtonHoverColors = ({ isNotificationRequested }: OutOfLuxButtonProps) => css`
    background-color: ${isNotificationRequested
        ? FunctionColor.function10
        : FunctionColor.function5};
    border: 1px solid
        ${isNotificationRequested ? FunctionColor.function10 : FunctionColor.function5};
`;

export const OutOfLuxButton = styled.button<{ isNotificationRequested: boolean }>`
    ${outOfLuxButtonBase}
    ${outOfLuxButtonColors}

    ${mediaMinWidth.sm} {
        &:hover {
            ${outOfLuxButtonHoverColors}
        }
    }
`;

export const OutOfLuxButtonText = styled(Text)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const IconWrapper = styled.div`
    margin-right: ${Spacer.XXS};
`;
